import React from 'react';
import TradingDecisionPage from '../components/trading-decision/TradingDecisionPage';

const TradingDecision = () => {
  return <TradingDecisionPage />;
};

export default TradingDecision;

